import React, { useEffect, useState } from 'react'
import styles from './index.module.less'
import { BackTop, Spin, Timeline } from 'antd'
import axios from 'axios'
export default function News() {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    axios.get('/api/news').then(res => {
      setData(res.data.mate.data)
      setLoading(false)
    })
  }, [])
  return (
    <div style={{ backgroundColor: '#F4F9FE' }}>
      <div className={styles.wrap}>
        <BackTop />
        <span className={styles.big_title}>新闻动态</span>
        {
          loading === true ?
            <div style={{ width: "100%", height: "60vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
              <Spin tip="loading..." style={{ fontSize: "24px" }} />
            </div> :
            <Timeline>
              {
                data.map(i => (
                  <Timeline.Item color='red' key={i.id}>
                    <div className={styles.item} onClick={() => { window.location.href = i.url }}>
                      <img src={i.cover} alt="" />
                      <div>
                        <span className={styles.title}>{i.title}</span>
                        <span className={styles.cont}>
                          {i.content}
                        </span>
                        <span className={styles.time}>{i.createtime}</span>
                      </div>
                    </div>
                  </Timeline.Item>
                ))
              }
            </Timeline>
        }
      </div>
    </div>
  )
}
